<template>
	<div class="nft-tile-container text-center" @click="onSelect">
		<div :style="nftStyle" class="nft-tile">
			<div v-if="icon !== ''" class="pt-4">
				<i :class="`fa ${icon} fa-5x`"></i>
			</div>
			<div class="count-container">
				<span class="count p-2">{{count}}</span>
			</div>
			<div class="nft-detail">{{ nft.name }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "DefaultNFTTile",
	props: {
		icon: {
			type: String,
		},
		count: {
			type: Number,
		},
		nft: {
			type: Object,
			default() {
				return {
					isDangerous: false,
					name: "Unverified Collections",
					image: "",
				}
			}
		}
	},
	computed: {
		nftStyle: function () {
			return {
				backgroundImage: `url("${this.nft.image}")`
			}
		}
	},
	methods: {
		onSelect: function () {
			this.$emit("selected", this.nft)
		}
	}
}
</script>

<style scoped>

.nft-tile {
	position: relative;
	min-height: 200px;
	max-height: 200px;
	width: 100%;
	background: #222;
	background-size: cover;
	background-position: center;
	transition: all 0.3s ease;
}

.nft-tile-container {
	border: 2px solid transparent;
	transition: all 0.3s ease;
	cursor: pointer;
}

.nft-tile-container:hover {
	border-color: rgba(255, 255, 255, 1);
	transform: scale(1.1);
}

/*.nft-tile-container:hover .nft-tile {*/
/*	transform: scale(1.1);*/
/*}*/

.nft-tile-container:hover .nft-detail {
	background-color: rgba(0, 0, 0, 0.9);
}

.nft-detail {
	position: absolute;
	bottom: 0;
	left: 0;
	transition: background-color 0.4s ease;
	background: rgba(0, 0, 0, 0.6);
	width: 100%;
}

.count-container {
	position: absolute;
	top: 38%;
	width: 100%;
	text-align: center;
	-ms-transform: translateY(-38%);
	transform: translateY(-38%);
}

.count {
	background: rgba(0, 0, 0, 0.6);
	border-radius: 7px;
	padding-left: 5px;
	padding-right: 5px;
	margin: auto;
	font-weight: bold;
}

</style>